
import { combineReducers } from 'redux';

import katuzeInfo from './katuzeInfo';

export function getKatuzeInfo(state) {
    return state.katuzeInfo;
}

export default combineReducers({
    katuzeInfo: katuzeInfo()
});
